module.exports = __webpack_public_path__ + "img/tab2.e3020c16.png";